import { RouteObject } from "react-router";
import { VbsBaseDataRoute } from "@/routes/base-data/processes/vbs/vbs-base-data-route";
import { RltBaseDataRoute } from "@/routes/base-data/processes/rlt/rlt-base-data-route";
import { vbsBaseDataRoutes } from "@/routes/base-data/processes/vbs/vbs-base-data-routes";
import { rltBaseDataRoutes } from "@/routes/base-data/processes/rlt/rlt-base-data-routes";
import { HtzBaseDataRoute } from "@/routes/base-data/processes/htz/htz-base-data-route";
import { htzBaseDataRoutes } from "@/routes/base-data/processes/htz/htz-base-data-routes";

export const processesBaseDataRoutes: RouteObject[] = [
  {
    path: "htz",
    element: <HtzBaseDataRoute />,
    children: htzBaseDataRoutes,
  },
  {
    path: "rlt",
    element: <RltBaseDataRoute />,
    children: rltBaseDataRoutes,
  },
  {
    path: "vbs",
    element: <VbsBaseDataRoute />,
    children: vbsBaseDataRoutes,
  },
];
